export const Bio = {
  name: "Aditya Kumar",
  roles: [
    "Frontend Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description: "A dedicated and innovative Frontend Developer with 1.5 years of hands-on experience in building responsive web-applications using React framework.Passionate about creating efficient and user-friendly interfaces, seeking opportunities to contribute technical expertise and creativity to a dynamic team.",
  github: "https://github.com/Aditya7j",
  resume:
    "https://drive.google.com/file/d/19YMzisacjFzImxWr_zxUAeNsQo0UkWyY/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/aditya-kumar-898a9814a/",
};


export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "TypeScript",
        image:
          "https://www.svgrepo.com/show/374144/typescript.svg"
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Material UI",
        image:"https://cdn-media-1.freecodecamp.org/images/1*FDNeKIUeUnf0XdqHmi7nsw.png"
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image: 
          "https://media.licdn.com/dms/image/D4E12AQEBg943ptCYpg/article-cover_image-shrink_720_1280/0/1686391647921?e=2147483647&v=beta&t=sTfwUvcIfW7Fuby7hMluDfuRJK3HfYMMWc2SyZR7-GA"
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://camo.githubusercontent.com/fbfcb9e3dc648adc93bef37c718db16c52f617ad055a26de6dc3c21865c3321d/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f6769742d73636d2f6769742d73636d2d69636f6e2e737667",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.testautomatisierung.org/wp-content/uploads/postman.jpg"
      },
      {
        name: "SharePoint Framework",
        image:
          "https://altn8.co.ke/wp-content/uploads/2021/04/SPFx.png"
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://static.wixstatic.com/media/a16c70_66558d16022144629d4d1d073893825b~mv2.jpg/v1/fit/w_2500,h_1330,al_c/a16c70_66558d16022144629d4d1d073893825b~mv2.jpg",
    role: "Associate Engineer",
    company: "Twinleaves Ecommerce Pvt. Ltd.",
    date: "Sept 2022 - Jan 2024",
    desc: "As an Associate Engineer at Twinleaves Ecommerce Pvt. Ltd. from September 2022 to January 2024, I played a pivotal role in developing and enhancing the Warehouse and Retail Management System. One of my key contributions was designing and implementing a user-friendly Point of Sales (POS) management system using cutting-edge technologies such as ReactJS and Material-UI.During my tenure, I collaborated closely with cross-functional teams to gather requirements, design solutions, and implement features that streamlined operations and improved efficiency. I leveraged my expertise in HTML, CSS, Sass, ReactJS, JavaScript, and Material-UI to deliver high-quality, scalable solutions that met the needs of both internal stakeholders and end users.My responsibilities included analyzing business requirements, architecting solutions, writing clean and maintainable code, conducting code reviews, and ensuring adherence to best practices and coding standards. Additionally, I actively participated in team meetings, brainstorming sessions, and knowledge-sharing initiatives to foster a culture of continuous learning and innovation.Through my dedication, problem-solving skills, and commitment to excellence, I contributed to the successful delivery of projects on time and within budget. I embraced challenges, adapted to evolving technologies, and continuously sought opportunities for self-improvement to stay at the forefront of software development.Overall, my experience at Twinleaves Ecommerce Pvt. Ltd. equipped me with valuable skills, insights, and experiences that have furthered my professional growth and prepared me for future challenges in the ever-changing landscape of technology and engineering.",
    skills: [
      "Html",
      "Css",
      "Sass",
      "React JS",
      "JavaScript",
      "Material-UI",
    ],
  },
];

export const education = [
  {
    id: 0,
    img: "https://images.shiksha.com/mediadata/images/1683793709phps6rTFg.jpeg",
    school: "Haldia Institue of Technolog,Halida West Bengal",
    date: "Aug 2017 - Aug 2021",
    grade: "7.98 CGPA",
    desc: "I am completed pursuing a Bachelor's degree in Computer Science and Engineering at Haldia Institue of Technolog,Halida.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "data:image/png;base64,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",
    school: "Masai School",
    date: "Oct 2021 - Apr 2022",
    desc: "I completed my full Stack web develpoment course at masai school.",
  },
  {
    id: 2,
    img: "https://play-lh.googleusercontent.com/4pir3XTsYVcasGbGhNk2kYv6cBQzcq217XxdXgwFZ_IYEtHQ81Rm2a6r6iofvBvqvkE",
    school: "D.A.V Public School, Kusunda",
    date: "Mar 2016 - Feb 2017",
    grade: "71.2%",
    desc: "I completed my class 12 education at D.A.V Public School, Kusunda where I studied Science.",
    degree: "CBSE(XII), Science",
  },
  {
    id: 3,
    img: "https://play-lh.googleusercontent.com/4pir3XTsYVcasGbGhNk2kYv6cBQzcq217XxdXgwFZ_IYEtHQ81Rm2a6r6iofvBvqvkE",
    school: "D.A.V Public School, Kusunda",
    date: "Feb 2014 - Feb 2015",
    grade: "74.4%",
    desc: "I completed my class 10 education at D.A.V Public School, Kusunda where I studied Science.",
    degree: "CBSE(X), Science",
  },
];

export const projects = [
  {
    id: 0,
    title: "Point of Sale(POS)",
    date: "Jan 2023 - Jan 2024",
    description:"Developed a sophisticated Point of Sale (POS) system leveraging React JavaScript and Material-UI, equipped with advanced features to streamline retail operations. Seamlessly integrated user authentication to ensure secure access, allowing staff members to log in and commence their shifts effortlessly.The system's intuitive interface facilitates efficient navigation, enabling users to browse products categorized by type or section, optimizing the shopping experience. Leveraging real-time data synchronization, staff can initiate and terminate sessions for each business day, ensuring accurate tracking and reporting of sales activities.Furthermore, the POS system supports dynamic ordering capabilities, enabling staff to place real-time orders for customers with ease. Additionally, customers can input their unique identification numbers to accumulate loyalty points, enhancing customer engagement and fostering brand loyalty.At checkout, customers have the option to redeem accumulated loyalty points, providing an added incentive for repeat business. Through meticulous design and implementation, the POS system delivers a seamless and efficient retail experience, empowering businesses to drive sales and enhance customer satisfaction.",
    image:"https://www.acecloudhosting.com/wp-content/uploads/2019/05/point-of-sale-system-for-business.jpg",
    tags: ["React Js", "Material-Ui", "JavaScript"],
    category: "web app",
    webapp: "https://stage-pos.palletnow.co/products/homepage",
  },
  {
    id: 1,
    title: "boAt",
    date: "June 2021",
    description:"Designed and developed a feature-rich full-stack web application offering seamless user registration, login, and shopping experiences. Implemented an intuitive user interface with React.js and Redux, backed by a robust backend infrastructure using Node.js, Express.js, and MongoDB. The Men Grooming section showcases premium products, allowing users to browse, add items to cart, and securely place orders. Advanced features include real-time inventory management, order tracking, and personalized recommendations, enhancing overall user satisfaction and engagement. ",
    image:
      "https://user-images.githubusercontent.com/89588001/181035006-e5d53e3f-710d-46f4-a9a5-1e0ab59595e3.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js","JavaScript"],
    category: "web app",
    github: "https://github.com/Aditya7j/boAt--project",
    webapp: "https://inspiring-pika-2690be.netlify.app/",
    member: [
      {
        name: "Aditya Kumar",
        img: "https://avatars.githubusercontent.com/u/89588001?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
    ],
  },
  {
    id: 2,
    title: "Netmeds",
    date: "Apr 2021",
    description:"Designed and developed a feature-rich full-stack web application offering seamless user registration, login, and shopping experiences. Implemented an intuitive user interface with React.js and Redux, backed by a robust backend infrastructure using Node.js, Express.js, and MongoDB. The Men Grooming section showcases premium products, allowing users to browse, add items to cart, and securely place orders. Advanced features include real-time inventory management, order tracking, and personalized recommendations, enhancing overall user satisfaction and engagement. ",
    image:
      "https://aditya-portfolio-007.netlify.app/image/netmeds.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js","JavaScript"],
    category: "web app",
    github: "https://github.com/Aditya7j/Netmeds",
    webapp: "https://netmeds-shop.netlify.app/",
    member: [
      {
        name: "Aditya Kumar",
        img: "https://avatars.githubusercontent.com/u/89588001?v=4",
        linkedin: "https://www.linkedin.com/in/aditya-kumar-898a9814a/",
        github: "https://github.com/Aditya7j",
      },
    ],
  },
  {
    id: 3,
    title: "GAP Inspired",
    date: "Jan 2021",
    description:"Designed and developed a feature-rich full-stack web application offering seamless user registration, login, and shopping experiences. Implemented an intuitive user interface with React.js and Redux, backed by a robust backend infrastructure using Node.js, Express.js, and MongoDB. The Men Grooming section showcases premium products, allowing users to browse, add items to cart, and securely place orders. Advanced features include real-time inventory management, order tracking, and personalized recommendations, enhancing overall user satisfaction and engagement. ",
    image:
      "https://aditya-portfolio-007.netlify.app/image/gap1.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js"],
    category: "web app",
    github: "https://github.com/Aditya7j/Gap-backend",
    webapp: "https://gap-project.herokuapp.com/home",
    member: [
      {
        name: "Aditya Kumar",
        img: "https://avatars.githubusercontent.com/u/89588001?v=4",
        linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
        github: "https://github.com/rishavchanda/",
      },
    ],
  },


];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2021, text: "Founded JavaScript Mastery" },
  { year: 2022, text: "Started my professional Carrer" },

];
